import { fg } from '@atlassian/jira-feature-gating';

export const getIsIframe: () => boolean | undefined = () => {
	if (!fg('jiv_22234_add_is_iframe_to_route_analytics_attr')) {
		return undefined;
	}
	try {
		return typeof window !== 'undefined' && window.self !== window.top;
	} catch (e) {
		// Accessing window.top can throw a SecurityError in cross‑origin cases
		return true; // If we can't access top, we *are* in an iframe
	}
};
